// extracted by mini-css-extract-plugin
export default {"wrapper":"input-module--wrapper--20ae3"};